import React, { useState, useEffect } from "react";
import "./OnionBuy.css";
import { useAuth } from "./AuthContext";
import { Link } from "react-router-dom";
import Whyglobal from "../Components/Whyglobal";

const BoltsAndHingesBuys = [
  {
    name: "Rajiv Sharma",
    email: "rajivsharma@gmail.com",
    mobileNumber: "9876543210",
    locationandDate: "Delhi, 03-05-2025",
    lookingFor: "Looking for SS Hinges in bulk",
    productOrService: "Hinges",
    quantity: 5000,
    unit: "pcs",
  },
  {
    name: "Priya Mehta",
    email: "priyamehta@yahoo.com",
    mobileNumber: "9123456789",
    locationandDate: "Mumbai, 02-05-2025",
    lookingFor: "Need Bolts for construction use",
    productOrService: "Bolts",
    quantity: 3000,
    unit: "pcs",
  },
  {
    name: "Amit Verma",
    email: "amitverma@outlook.com",
    mobileNumber: "9988776655",
    locationandDate: "Chennai, 03-05-2025",
    lookingFor: "Heavy-duty Hinges required",
    productOrService: "Hinges",
    quantity: 4000,
    unit: "pcs",
  },
  {
    name: "Sneha Joshi",
    email: "snehajoshi@gmail.com",
    mobileNumber: "9911223344",
    locationandDate: "Pune, 02-05-2025",
    lookingFor: "MS Bolts for project work",
    productOrService: "Bolts",
    quantity: 3500,
    unit: "pcs",
  },
  {
    name: "Vikram Patel",
    email: "vikrampatel@gmail.com",
    mobileNumber: "9845123456",
    locationandDate: "Ahmedabad, 28-04-2025",
    lookingFor: "Industrial-grade Hinges requirement",
    productOrService: "Hinges",
    quantity: 6000,
    unit: "pcs",
  },
];

const BoltsAndHingesBuy = () => {
  const { userId } = useAuth();
  const [userIsPremium, setUserIsPremium] = useState(false);
  const [shownNumbers, setShownNumbers] = useState([]);
  const [leadsViewed, setLeadsViewed] = useState(0);

  useEffect(() => {
    if (!userId) return;
    const storedViewedLeads =
      JSON.parse(localStorage.getItem(`boltsHingesViewedLeads_${userId}`)) ||
      [];
    setShownNumbers(storedViewedLeads);

    fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/getUserWithPremiumStatus/${userId}`
    )
      .then((res) => res.json())
      .then((data) => {
        setUserIsPremium(data.isPremium);
        setLeadsViewed(data.leadsViewed);
      })
      .catch((err) => console.error("Fetch error:", err));
  }, [userId]);

  const toggleNumber = async (index) => {
    if (!userIsPremium) return;
    if (leadsViewed >= 25) {
      alert("You have reached the limit of 25 leads viewed per month.");
      return;
    }
    if (shownNumbers.includes(index)) return;

    const updatedShownNumbers = [...shownNumbers, index];
    setShownNumbers(updatedShownNumbers);
    localStorage.setItem(
      `boltsHingesViewedLeads_${userId}`,
      JSON.stringify(updatedShownNumbers)
    );

    const buyer = BoltsAndHingesBuys[index];
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/incrementLeadsViewed/${userId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            buyerName: buyer.name,
            mobileNo: buyer.mobileNumber,
          }),
        }
      );
      if (response.ok) {
        const data = await response.json();
        setLeadsViewed(data.leadsViewed);
      } else {
        const errorData = await response.json();
        console.error("Error incrementing leads viewed:", errorData.error);
      }
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  return (
    <>
      <div className="container">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li>/</li>
          <li className="breadcrumb-item active">Fresh Leads</li>
        </ol>
      </div>
      <div className="containersx">
        <div className="browsers" style={{ width: "200px", padding: "10px" }}>
          <h3 style={{ marginTop: "30px" }}>Browse by State</h3>
          <ul className="flt-list cust-scroll" id="state-lists">
            <li>
              <Link to="#">All India</Link>
            </li>
            <li>
              <Link to="#">Delhi</Link>
            </li>
            <li>
              <Link to="#">Maharashtra</Link>
            </li>
            <li>
              <Link to="#">Karnataka</Link>
            </li>
            <li>
              <Link to="#">West Bengal</Link>
            </li>
            <li>
              <Link to="#">Tamil Nadu</Link>
            </li>
          </ul>

          <ul style={{ marginTop: "20px" }} className="flt-list cust-scroll">
            <h3>All Category</h3>
            <li>
              <Link to="#">Bolts</Link>
            </li>
            <li>
              <Link to="#">Hinges</Link>
            </li>
          </ul>
        </div>

        <div className="buyers">
          {BoltsAndHingesBuys.map((buyer, index) => (
            <div key={index} className="buyer-card">
              <h2 style={{ color: "red" }}>{buyer.lookingFor}</h2>
              <p>
                <strong>Buyer Name:</strong> {buyer.name}
              </p>
              <p>
                <strong>Quantity:</strong> {buyer.quantity} {buyer.unit}
              </p>
              <p>
                <strong>Date:</strong> {buyer.locationandDate}
              </p>
              <p>
                <strong>Mobile No.:</strong>{" "}
                {userIsPremium
                  ? shownNumbers.includes(index)
                    ? buyer.mobileNumber
                    : "********"
                  : "********"}
              </p>
              <div style={{ display: "flex", gap: "10px" }}>
                {userIsPremium && (
                  <button
                    className="detail-btn"
                    style={{
                      padding: "5px 10px",
                      background: "#f7f1f1",
                      color: "orange",
                      borderRadius: "3px",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleNumber(index)}
                  >
                    Click to see
                  </button>
                )}
              </div>
              <div className="btns-imp">
                <Link to="/login">
                  <button className="detailing-btn">View More</button>
                </Link>
                <Link to="/register-Company">
                  <button className="regis-btn">Register Now</button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="sidebar">
          <div className="mains-slide">
            <div className="tk23-hkCont_onergt">
              <div className="tk23-hkCont_premserv__box">
                <h1 className="tk23-hkCont_premserv__ttl">
                  Our Membership Plans
                </h1>
                {["Standard Plan", "Advance Plan", "Premium Plan"].map(
                  (plan, i) => (
                    <div className="tk23-hkCont_premserv__list" key={i}>
                      <Link to="/packages">
                        <div className="tk23-hkCont_premservs">
                          <span
                            className="fontss"
                            style={{ backgroundColor: "#fff" }}
                          >
                            {plan}
                          </span>
                        </div>
                      </Link>
                    </div>
                  )
                )}
                <Link to="/packages">
                  <div className="reach">
                    <span className="reahhere">Call Now</span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <Whyglobal />
      </div>
    </>
  );
};

export default BoltsAndHingesBuy;
